<template>
    <FullCalendar :events="events" :options="options" />
</template>

<script>
import { ref, computed } from 'vue'
import '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import FullCalendar from 'primevue/fullcalendar';
import zhcnLocale from '@fullcalendar/core/locales/zh-cn';

export default {
    name: 'tw-fullcalendar',
    components: {
        FullCalendar
    },
    setup(props) {
        const date = new Date();
        const today = date.getFullYear() + "-" 
        + (date.getMonth() < 9 ? ("0"+(date.getMonth()+1)) : (date.getMonth()+1)) 
        + "-" + (date.getDate() < 10 ? ("0"+(date.getDate())) : (date.getDate()));

        const options = ref({
            plugins:[dayGridPlugin, timeGridPlugin, interactionPlugin],
            initialDate : today,
            headerToolbar: {
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay'
            },
            editable: true,
            selectable:true, 
            selectMirror: true, 
            dayMaxEvents: true,
            locales: [zhcnLocale],
            locale: 'zh-cn'
        });

        const events = computed(() => {
            const datas = props.data_source?.datas;

            if(datas){
                if (Array.isArray(datas) && props.title_name && props.start_name && props.end_name && props.url_name) {
                    const array = []

                    datas.forEach(el => {
                        array.push({
                            title: el[props.title_name],
                            start: el[props.start_name],
                            end: el[props.end_name],
                            url: el[props.url_name] ?? ''
                        })
                    })

                    return array
                } else {
                    // 属性未选完，不用提示错误
                    // ElMessage.error('饼图：请检查【数据源】数据格式');
                    return [];
                }
            }else{
                return []
            }
        })

        return {
            options,
            events
        }
    },
    props: {
        data_source: {
            type: Object,
            default: function() {
                return { }
            }
        },
        title_name: {
            type: String,
            default: ''
        },
        start_name: {
            type: String,
            default: ''
        },
        end_name: {
            type: String,
            default: ''
        },
        url_name: {
            type: String,
            default: ''
        }
    }
}

</script>
<style scoped lang='scss'>

</style>